import { MainRows, ArticleSt } from "./styled";

import Button from "./Button";
interface ArticleProps {
  title: string;
  active: string;
  buttons: any;
  selectRows: any;
}
export default function Rows({
  title,
  active,
  buttons,
  selectRows,
}: ArticleProps) {
  const first = [buttons[0], buttons[1], buttons[2]];
  const second = [buttons[3], buttons[4], buttons[5]];
  const third = [buttons[6], buttons[7], buttons[8]];

  return (
    <ArticleSt>
      <h2>{title}</h2>
      <MainRows>
        {first.map((b: string) => (
          <Button
            width="56px"
            height="56px"
            size="18px"
            active={active}
            key={b}
            func={selectRows}
          >
            {b}
          </Button>
        ))}
      </MainRows>

      <MainRows>
        {second.map((b: string) => (
          <Button
            width="56px"
            height="56px"
            size="18px"
            active={active}
            key={b}
            func={selectRows}
          >
            {b}
          </Button>
        ))}
      </MainRows>

      <MainRows>
        {third.map((b: string) => (
          <Button
            width="56px"
            height="56px"
            size="18px"
            active={active}
            key={b}
            func={selectRows}
          >
            {b}
          </Button>
        ))}
      </MainRows>
    </ArticleSt>
  );
}
